var contentInnerStyle = 'fx_b722dd09_17el7vp3';
var contentStyle = 'fx_b722dd09_17el7vp2';

export { contentInnerStyle, contentStyle };
//# sourceMappingURL=styles.vanilla.mjs.map
